var map = {
	"./restaurant1.jpg": 2357,
	"./restaurant10.jpg": 5949,
	"./restaurant11.jpg": 3295,
	"./restaurant12.jpg": 3606,
	"./restaurant13.jpg": 4415,
	"./restaurant14.jpg": 4348,
	"./restaurant15.jpg": 9407,
	"./restaurant16.jpg": 2440,
	"./restaurant17.jpg": 61,
	"./restaurant18.jpg": 1682,
	"./restaurant19.jpg": 4964,
	"./restaurant2.jpg": 4102,
	"./restaurant20.jpg": 2460,
	"./restaurant21.jpg": 8524,
	"./restaurant22.jpg": 8766,
	"./restaurant23.jpg": 2235,
	"./restaurant24.jpg": 3015,
	"./restaurant25.jpg": 1241,
	"./restaurant26.jpg": 3790,
	"./restaurant27.jpg": 5967,
	"./restaurant28.jpg": 6927,
	"./restaurant29.jpg": 2846,
	"./restaurant3.jpg": 4037,
	"./restaurant30.jpg": 153,
	"./restaurant31.jpg": 6800,
	"./restaurant32.jpg": 72,
	"./restaurant33.jpg": 7498,
	"./restaurant34.jpg": 9354,
	"./restaurant35.jpg": 3000,
	"./restaurant36.jpg": 2697,
	"./restaurant37.jpg": 6911,
	"./restaurant38.jpg": 3183,
	"./restaurant39.jpg": 9811,
	"./restaurant4.jpg": 6613,
	"./restaurant40.jpg": 7379,
	"./restaurant41.jpg": 2252,
	"./restaurant42.jpg": 8937,
	"./restaurant43.jpg": 7555,
	"./restaurant44.jpg": 6678,
	"./restaurant45.jpg": 6453,
	"./restaurant46.jpg": 7049,
	"./restaurant47.jpg": 8413,
	"./restaurant48.jpg": 8174,
	"./restaurant49.jpg": 6659,
	"./restaurant5.jpg": 5998,
	"./restaurant50.jpg": 1533,
	"./restaurant51.jpg": 4375,
	"./restaurant52.jpg": 3928,
	"./restaurant53.jpg": 7347,
	"./restaurant54.jpg": 1044,
	"./restaurant55.jpg": 4850,
	"./restaurant56.jpg": 37,
	"./restaurant57.jpg": 4706,
	"./restaurant58.jpg": 6781,
	"./restaurant59.jpg": 7722,
	"./restaurant6.jpg": 6882,
	"./restaurant60.jpg": 9771,
	"./restaurant61.jpg": 6072,
	"./restaurant62.jpg": 5887,
	"./restaurant63.jpg": 7620,
	"./restaurant64.jpg": 6805,
	"./restaurant65.jpg": 2867,
	"./restaurant66.jpg": 5461,
	"./restaurant67.jpg": 524,
	"./restaurant68.jpg": 6153,
	"./restaurant69.jpg": 6450,
	"./restaurant7.jpg": 5315,
	"./restaurant70.jpg": 9507,
	"./restaurant71.jpg": 1955,
	"./restaurant72.jpg": 8813,
	"./restaurant73.jpg": 7968,
	"./restaurant74.jpg": 209,
	"./restaurant75.jpg": 401,
	"./restaurant76.jpg": 634,
	"./restaurant77.jpg": 9514,
	"./restaurant78.jpg": 9164,
	"./restaurant79.jpg": 6672,
	"./restaurant8.jpg": 2174,
	"./restaurant80.jpg": 3281,
	"./restaurant81.jpg": 1816,
	"./restaurant82.jpg": 6089,
	"./restaurant83.jpg": 5414,
	"./restaurant84.jpg": 7585,
	"./restaurant85.jpg": 7076,
	"./restaurant86.jpg": 6916,
	"./restaurant87.jpg": 4916,
	"./restaurant88.jpg": 3540,
	"./restaurant89.jpg": 360,
	"./restaurant9.jpg": 5532,
	"./restaurant90.jpg": 7418
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1672;